import type { EfGroupClass } from '@form-factory/schema/contracts'; // Assuming types are defined here

import { ClassCard } from './ClassCard';
import { Loader } from '../loader/Loader';

export interface ScheduleDisplayProps {
  classesData: EfGroupClass[];
  isLoading: boolean;
}

export function ScheduleDisplay({
  classesData,
  isLoading,
}: ScheduleDisplayProps) {
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      {classesData.length === 0 && (
        <p className='text-center text-gray-500'>Žádné lekce k zobrazení.</p>
      )}
      {[...classesData]
        .sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
        )
        .map(classItem => (
          <ClassCard key={classItem.classId} classData={classItem} />
        ))}
    </div>
  );
}
